// Chatbot Configuration
export const CHATBOT_CONFIG = {
    NAME: 'Spacey',
    AVATAR_PATH: '../../../assets/images/agent/spacey-2026-3d.svg',
    DEFAULT_COUNTRY: 'LK',
    DEFAULT_COORDINATES: {
        x: 80.0087746,
        y: 6.901608599999999
    },
    DEFAULT_TIME_UNIT: 'hour',
    MAX_MESSAGE_LENGTH: 1000,
    AUTO_CLOSE_DELAY: 300,
    PERSONALIZED_MESSAGE_DELAY: 100,
    SCROLL_BEHAVIOR: 'smooth'
};

// Chat Steps
export const CHAT_STEPS = {
    INITIAL: 1,
    WORKSPACE_SELECTION: 1,
    LOCATION_SELECTION: 2,
    PRICE_RANGE_SELECTION: 3,
    SPACE_RECOMMENDATION: 4,
    SPACE_SELECTION: 5,
    PREVIOUS_BOOKING_QUESTION: 1.5
};

// Message Types
export const MESSAGE_TYPES = {
    USER: 'user',
    BOT: 'bot'
};

// Loading Messages
export const LOADING_MESSAGES = {
    SEARCHING_SPACES: 'Searching for available spaces...',
    FINDING_PRICE_RANGES: 'Finding price ranges for your selection...',
    FINDING_BEST_SPACES: 'Finding the best spaces for you...',
    SENDING_MESSAGE: 'Sending...'
};

// Success Messages
export const SUCCESS_MESSAGES = {
    CONTACT_FORM_SUBMITTED: "Thank you! Your message has been sent. We'll get back to you soon.",
    SPACE_SELECTED: 'Perfect! I\'ve opened the booking page for',
    SPACES_FOUND: 'I found spaces that match your criteria. Here are the available options:'
};

// Error Messages
export const ERROR_MESSAGES = {
    GENERAL: 'Sorry, I could not process your request. You can type "agent" to speak with a human agent.',
    CONTACT_FORM_ERROR: "Sorry, there was an error sending your message. Please try again or contact us directly.",
    FORM_VALIDATION_ERROR: "Please check your form inputs and try again.",
    NO_WORKSPACE_OPTIONS: "Sorry, no workspace options are currently available. Please try again later.",
    WORKSPACE_OPTIONS_LOADING_ERROR: "Sorry, I'm having trouble loading workspace options. Please try again later.",
    NO_LOCATIONS_FOUND: "No locations found for the selected workspace type:",
    NO_SPACES_FOUND: "No spaces found for the selected location:",
    NO_PRICE_RANGES: "No price ranges could be generated from the available spaces for",
    NO_SPACES_IN_PRICE_RANGE: "No spaces found within the selected price range:",
    SEARCH_ERROR: "I'm having trouble searching for spaces right now. Please try again later.",
    PRICE_RANGE_ERROR: "I'm having trouble finding price ranges. Please try again later.",
    SPACES_ERROR: "I'm having trouble finding spaces. Please try again later."
};

// Info Messages
export const INFO_MESSAGES = {
    HELP: "Here's some helpful information about Spacey! Check out the info panel below or type.",
    CONTACT_AGENT: "I'll connect you with a human agent. Please fill out the contact form below.",
    WORKSPACE_OPTIONS_TITLE: "Choose a workspace type:",
    LOCATION_OPTIONS_TITLE: "Choose a location:",
    PRICE_RANGE_OPTIONS_TITLE: "Choose a price range:",
    RECOMMENDED_SPACES_TITLE: "Recommended Spaces:",
    FOLLOW_UP_OPTIONS_TITLE: "What would you like to do next?",
    FIND_SOMETHING_ELSE_TITLE: "No spaces found within the selected price range. Would you like to try a different price range or find something else?",
    PREVIOUS_BOOKING_QUESTION: "Do you want to book the same space?",
    SPACE_OPENED: "Perfect! I've opened the booking page for",
    SELECT_DATE_TIME: "You can now select your preferred date and time.",
    CONTACT_AGENT_AFTER_SPACE: "Need help with this space?",
    FIND_SOMETHING_ELSE_AFTER_SPACE: "Not what you're looking for?"
};

// Form Labels and Placeholders
export const FORM_LABELS = {
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE_NUMBER: 'Phone Number',
    MESSAGE: 'Message'
};

export const FORM_PLACEHOLDERS = {
    NAME: 'Your Name',
    EMAIL: 'Your Email',
    PHONE_NUMBER: 'Phone Number (Optional)',
    MESSAGE: 'Your Message'
};

export const FORM_BUTTONS = {
    SEND_MESSAGE: 'Send Message',
    CANCEL: 'Cancel',
    LOGIN: 'Log In',
    RELOAD: 'Restart Chat',
    CLOSE: 'Close'
};

// Button Actions
export const BUTTON_ACTIONS = {
    YES: 'Yes',
    NO: 'No',
    FIND_SOMETHING_ELSE: 'Find Something Else',
    CONTACT_AGENT: 'Contact Agent'
};

// Price Range Defaults
export const DEFAULT_PRICE_RANGES = [
    { label: 'LKR 1000 - 2500', value: '1000-2500' },
    { label: 'LKR 2500 - 5000', value: '2500-5000' },
    { label: 'LKR 5000+', value: '5000+' }
];

// Country Mappings
export const COUNTRY_MAPPINGS = {
    LK: 'Sri-Lanka',
    AU: 'Australia',
    SG: 'Singapore',
    MY: 'Malaysia',
    IN: 'India',
    UK: 'United Kingdom',
    US: 'United States'
};

// API Endpoints
export const API_ENDPOINTS = {
    USER_DATA: 'booking/userData',
    SPACE_ACTIVITIES: 'space/space-activities',
    EVENT_TYPE_MAP: 'space/event-type-map',
    SEARCH_MAP: 'search/map'
};

// Search Parameters
export const SEARCH_PARAMS = {
    CATEGORY: 'Work',
    DEFAULT_COUNTRY: 'LK'
};

// UI Constants
export const UI_CONSTANTS = {
    MAX_SPACES_TO_SHOW: 5,
    SPACE_IMAGE_DIMENSIONS: {
        width: '60px',
        height: '75px',
        maxWidth: '60px',
        maxHeight: '70px',
        minWidth: '60px',
        minHeight: '75px'
    },
    SPACE_PLACEHOLDER_EMOJI: '🏢',
    SELECTED_INDICATOR: '✓'
};

// Validation Rules
export const VALIDATION_RULES = {
    NAME: {
        MIN_LENGTH: 2,
        MAX_LENGTH: 50
    },
    MESSAGE: {
        MIN_LENGTH: 10,
        MAX_LENGTH: 1000
    },
    EMAIL: {
        REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    },
    PHONE: {
        REGEX: /^(\+?[1-9][\d]{6,15}|0[1-9][\d]{6,14})$/
    }
};

// Development Configuration
export const DEV_CONFIG = {
    DEBUG_LOGGING: process.env.NODE_ENV === 'development',
    CONSOLE_PREFIX: 'Chatbot popup visibility check:',
    BOOKING_PROCESS_DETECTED: '✅ Booking process question detected! Triggering response...'
};

// Contact Form Messages
export const CONTACT_FORM_MESSAGES = {
    TITLE: "Contact Our Agent",
    SUCCESS: "Thank you! Your message has been sent. We'll get back to you soon.",
    ERROR: "Sorry, there was an error sending your message. Please try again or contact us directly.",
    VALIDATION_ERROR: "Please check your form inputs and try again.",
    AGENT_PHONE: "0117 811 811",
    AGENT_MESSAGE: "Need immediate assistance? Call our agent directly at:"
};
